import { Cell as CellBase } from '@react-stately/table';
import { CellProps as CellBaseProps } from '@react-types/table';

export type CellProps = CellBaseProps;

// Override TS for Cell to support NextUI specific props.
const Cell = CellBase as (props: CellProps) => React.JSX.Element;

export default Cell;
